/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
var name = 'ArtiWeb';
var keywords = ['Search'];
var category = 'navigation';
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M49.8562942,4.7051173 L17.8986514,18.0303101 L4.70388385,49.9681318 L17.8246068,81.8999272 L49.7404305,95.2930724 L82.0343162,82.0261274 L95.2928445,50.0032549 L81.8791034,17.8246498 L49.8562942,4.7051173 Z",
  strokeWidth: "5",
  fill: "#4997D2"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#343434",
  strokeWidth: "1",
  points: "49.6257258 24 68.357784 31.6765802 73.5231155 44.0713612 81 50.6348885 73.8223738 56.2494264 68.9076335 68.7066902 50.125 76.8463227 30.8916204 69.1634491 25.7443958 56.6331323 18 50.4550798 25.9293003 43.9145027 31.4258247 31.6765802"
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "#343434",
  strokeWidth: "1",
  points: "49.8859212 14 75.3404748 24.4285618 86 50 75.4597367 75.4575394 49.7976859 86 24.4285857 75.3541196 14 49.9741565 24.4870111 24.5904361",
  fill: "none"
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "#343434",
  strokeWidth: "1",
  points: "49.9492983 34 61.2624333 38.6349164 66 50 61.3154385 61.314462 49.9100826 66 38.634927 61.2684976 34 49.988514 38.6608938 38.7068605",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.625,49.8374456 L49.625,7.7086653",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.125,92.8386552 L50.125,50.5785268",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  transform: "translate(50.000000, 71.500000) scale(1, -1) translate(-50.000000, -71.500000) ",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50,50 L20.0006041,20.0006041",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50,50 L20.1973684,79.8026316",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50,50 L79.9993959,20.0006041",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50,50 L80.0329624,80.0329624",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5,71 L28.5,29.1470979",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  transform: "translate(28.500000, 50.000000) rotate(-90.000000) translate(-28.500000, -50.000000) ",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.5,70.9410053 L71.5,29",
  stroke: "#3D3D3D",
  strokeWidth: "0.5",
  strokeLinecap: "square",
  transform: "translate(71.500000, 50.000000) rotate(-90.000000) translate(-71.500000, -50.000000) ",
  fill: "none"
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "none",
  points: "19.1939643 50.3782521 37 38.8904324 37 34 16 47.2492164 16 52.5563823 37 67 37 61.8431492"
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "none",
  transform: "translate(73.500000, 50.500000) scale(-1, 1) translate(-73.500000, -50.500000) ",
  points: "66.1939643 50.3782521 84 38.8904324 84 34 63 47.2492164 63 52.5563823 84 67 84 61.8431492"
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "none",
  points: "54.0748936 27 59 27 45.0481884 74 40 73.9686587"
})), meta);